import { makeStyles } from '@material-ui/core/styles'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'

import React from 'react'
const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '20px',
    width: '100%',
    '& th': {
      backgroundColor: '#F5F8FF',
      // color: 'white',
      fontSize: '14px',
      textAlign: 'center',
      fontWeight: 600,
      padding: '6px',
      textTransform: 'uppercase',
    },
    '& td': {
      fontSize: '14px',
      padding: '10px',
      textAlign: 'center',
    },
  },

  paddingCell: {
    borderRadius: '20px',
    width: '100%',
    '& th': {
      backgroundColor: '#F5F8FF',
      // color: 'white',
      fontSize: '14px',
      textAlign: 'center',
      fontWeight: 600,
      padding: '6px',
      textTransform: 'uppercase',
    },
    '& td': {
      fontSize: '14px',
      padding: '20px',
      textAlign: 'center',
    },
  },
  border: {
    '& th': {
      border: '1px solid grey',
    },
    '& td': {
      border: '1px solid grey',
    },
  },
}))

export default function CustomTable({ children, padding, className, tableId, border }) {
  const classes = useStyles()
  const renderClass = className ? `${className} ${classes.root}` : padding ? `${className} ${classes.paddingCell}` : border ? `${classes.root} ${classes.border}` : classes.root
  return (
    <TableContainer>
      <Table id={tableId} className={renderClass} stickyHeader>
        {children}
      </Table>
    </TableContainer>
  )
}
